import ChangeViewButton from '../../../forecast-app/shared/components/changeview/ChangeViewButton';
import ChangeViewGroupings, {OnGroupingsChange} from '../../../forecast-app/shared/components/changeview/ChangeViewGroupings';
import React from 'react';
import {FormattedMessage} from 'react-intl';
import {REPORT_COLUMNS} from './Constants';

interface ReportsPageChangeViewButtonProps {
	groupings: string[];
	onGroupingsChange: OnGroupingsChange;
}

const REPORTS_GROUPING = [REPORT_COLUMNS.TYPE, REPORT_COLUMNS.CREATED_BY, REPORT_COLUMNS.ACCESS, REPORT_COLUMNS.FAVORITES];

const ReportsPageChangeViewButton = ({groupings, onGroupingsChange}: ReportsPageChangeViewButtonProps): JSX.Element => {
	return (
		<ChangeViewButton>
			<ChangeViewGroupings maxLevel={3} groupings={groupings} onChange={onGroupingsChange}>
				{REPORTS_GROUPING.map(grouping => (
					<ChangeViewGroupings.Grouping key={grouping} value={grouping}>
						<FormattedMessage id={'report.column.' + grouping} />
					</ChangeViewGroupings.Grouping>
				))}
			</ChangeViewGroupings>
		</ChangeViewButton>
	);
};

export default ReportsPageChangeViewButton;
